<template>
  <div
    :class="[posterImageStatus ? 'noscroll product-con' : 'product-con']"
    ref="box"
    @scroll="onScroll"
  >
    <div
      class="header acea-row row-center-wrapper"
      :style="'opacity:' + opacity"
      ref="header"
    >
      <div
        class="item"
        :class="navActive === index ? 'on' : ''"
        v-for="(item, index) in navList"
        :key="index"
        @click="asideTap(index)"
      >
        {{ item }}
      </div>
    </div>
    <div id="title0">
      <product-con-swiper
        :img-urls="storeInfo.slider_image"
        :videoline="storeInfo.video_link"
      ></product-con-swiper>
      <div class="wrapper">
        <div class="share acea-row row-between row-bottom">
          <div class="money">
            ￥<span class="num">{{ storeInfo.price }}</span
            ><!-- <span class="num" >****</span> -->
            <span
              class="vip-money"
              v-if="storeInfo.ot_price && storeInfo.ot_price > 0"
              >原价：￥{{ storeInfo.ot_price }}</span
            >
          </div>
        </div>
        <div class="introduce">
          <div class="introduce-left">
            <div class="store-name">
              {{ storeInfo.store_name }}
            </div>
            <div class="labels">
              <div class="label">官方正品</div>
              <div class="label">境外直邮</div>
              <div class="label">正规清关</div>
            </div>
          </div>
          <div class="share-icon" @click="listenerActionSheet">
            <div class="iconfont icon-fenxiang"></div>
            <div>分享好友</div>
          </div>
        </div>
        <div class="stock acea-row row-between-wrapper">
          <div>庫存:{{ storeInfo.stock }}{{ storeInfo.unit_name }}</div>
          <div>銷量:{{ storeInfo.fsales }}{{ storeInfo.unit_name }}</div>
        </div>
        <div class="detail-content">
          <p>通用名：{{ storeInfo.general_name }}</p>
          <p>廠&#8195;商：{{ storeInfo.Authorized_holder }}</p>
          <!-- <p>產&#8195;地：{{ storeInfo.country }}</p> -->
        </div>
        <div class="tax-content">
          <div class="assurance tax-item">
            <div>保&#8195;障&nbsp;&nbsp;</div>
            <div
              class="assure"
              :style="{ backgroundColor: 'rgb(132,159,230)' }"
            >
              證照公示
            </div>
            <div
              class="assure"
              :style="{ backgroundColor: 'rgb(200,132,228)' }"
            >
              正品保障
            </div>
            <div
              class="assure"
              :style="{ backgroundColor: 'rgb(228,132,143)' }"
            >
              廠家授權
            </div>
            <div
              class="assure"
              :style="{ backgroundColor: 'rgb(230,191,132)' }"
            >
              香港直郵
            </div>
          </div>
          <div class="assurance tax-item" v-if="storeInfo.is_auth">
            <div>声&#8195;明&nbsp;&nbsp;</div>
            <div style="color:red;">
              五洲药物国际贸易有限公司为乐托品在大中华区唯一授权代理商,其他渠道不保证产品质量！
            </div>
          </div>
          <div class="assurance tax-item">
            <div>说&#8195;明&nbsp;&nbsp;</div>
            <div style="color:red;">
              {{storeInfo.prompt}}
            </div>
          </div>
          <div class="tax-item">
            运&#8195;費&nbsp;&nbsp;<span v-if="id == '5247'">39（包邮)</span
            ><span v-else>(請以提交訂單為準)</span>
          </div>
          <div class="tax-item">
            税&#8195;費&nbsp;&nbsp;<span v-if="id == '5247'"
              >单盒-56.94,双盒-113.1（由商家承担）</span
            ><span v-else>(請以提交訂單為準)</span>
          </div>
          <div class="assurance tax-item">
            <div>售&#8195;后&nbsp;&nbsp;</div>
            <div style="color:red;">
              由于商品为跨境直邮,一经发货,申请退款需承担产生的费用(有但不仅限运费、关税、退港费)！！
            </div>
          </div>
        </div>
        <div
          class="coupon acea-row row-between-wrapper"
          @click="couponTap"
          v-if="couponList.length"
        >
          <div class="hide line1 acea-row">
            優惠券：
            <div
              class="activity"
              v-for="(item, index) in couponList"
              :key="index"
            >
              滿{{ item.use_min_price }}減{{ item.coupon_price }}
            </div>
          </div>
          <div class="iconfont icon-jiantou"></div>
        </div>
        <div class="coupon acea-row row-between-wrapper" v-if="activity.length">
          <div class="line1 acea-row">
            活&nbsp;&nbsp;&nbsp;动：
            <div
              v-for="(item, index) in activity"
              :key="index"
              @click="goDetail(item)"
            >
              <div
                class="acea-row row-center-wrapper"
                v-if="item.type === '1'"
                :class="{
                  activity_pin: index === 0,
                  activity_miao: index === 1,
                  activity_kan: index === 2
                }"
              >
                <span class="iconfonts iconfont icon-shenhezhong"></span>
                <span class="activity_title">&nbsp;參與秒殺</span>
              </div>
              <div
                class="acea-row row-center-wrapper"
                v-if="item.type === '2'"
                :class="{
                  activity_pin: index === 0,
                  activity_miao: index === 1,
                  activity_kan: index === 2
                }"
              >
                <span class="iconfonts iconfont icon-kanjia"></span>
                <span class="activity_title">&nbsp;参与砍价</span>
              </div>
              <div
                class="acea-row row-center-wrapper"
                v-if="item.type === '3'"
                :class="{
                  activity_pin: index === 0,
                  activity_miao: index === 1,
                  activity_kan: index === 2
                }"
              >
                <span class="iconfonts iconfont icon-pintuan"></span>
                <span class="activity_title">&nbsp;参与拼团</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="attribute acea-row row-between-wrapper"
        @click="selecAttrTap"
        v-if="attr.productAttr.length"
      >
        <div>
          {{ attrTxt }}：<span class="atterTxt">{{ attrValue }}</span>
        </div>
        <div class="iconfont icon-jiantou"></div>
      </div>
      <!-- <div
        class="store-info"
        v-if="system_store.id !== undefined && storeSelfMention"
      >
        <div
          class="acea-row row-between-wrapper store-box"
          @click="showStoreList"
        >
          <div class="title">门店信息</div>
          <div class="iconfont icon-jiantou"></div>
        </div>
        <div class="info acea-row row-between-wrapper">
          <div class="pictrue"><img :src="storeItems.image" /></div>
          <div class="text">
            <div class="name line1">
              {{ storeItems.name }}
            </div>
            <div class="address acea-row row-middle" @click="showChang">
              <span class="addressTxt line1 address_tit"
                >{{ storeItems.address
                }}{{ ", " + storeItems.detailed_address }}</span
              ><span class="iconfont icon-youjian"></span>
            </div>
          </div>
          <div class="addressBox">
            <a
              class="iconfont icon-dadianhua01 font-color-red phone"
              :href="'tel:' + storeItems.phone"
            ></a>
            <div
              class="addressTxt corlor-red"
              @click="showChang"
              v-if="storeItems.range"
            >
              距离{{ storeItems.range }}千米
            </div>
          </div>
        </div>
      </div> -->
      <!--
      <div
        class="store-info"
        v-if="
          system_store.id !== undefined &&
            storeSelfMention &&
            Object.keys(hospitalItems).length > 0
        "
      >
        <div
          class="acea-row row-between-wrapper store-box"
          @click="showHospitalList"
        >
          <div class="title">已认证的医院,可就近预约</div>
          <div class="iconfont icon-jiantou"></div>
        </div>
        <div class="info acea-row row-between-wrapper">
          <div class="pictrue"><img :src="hospitalItems.image" /></div>
          <div class="text">
            <div class="name line1">
              {{ hospitalItems.name }}
            </div>
            <div class="address acea-row row-middle" @click="showHospital">
              <span class="addressTxt line1 address_tit"
                >{{ hospitalItems.address
                }}{{ ", " + hospitalItems.detailed_address }}</span
              ><span class="iconfont icon-youjian"></span>
            </div>
          </div>
          <div class="addressBox">
            <a
              class="iconfont icon-dadianhua01 font-color-red phone"
              :href="'tel:' + hospitalItems.phone"
            ></a>
            <div
              class="addressTxt corlor-red"
              @click="showHospital"
              v-if="hospitalItems.range"
            >
              距离{{ hospitalItems.range }}千米
            </div>
          </div>
        </div>
      </div>
    --></div>
    <div class="userEvaluation" id="title1">
      <div class="title acea-row row-between-wrapper">
        <div>用戶評價({{ replyCount }})</div>
        <router-link :to="{ path: '/evaluate_list/' + id }" class="praise"
          ><span class="font-color-red">{{ replyChance }}%</span>好評率<span
            class="iconfont icon-jiantou"
          ></span
        ></router-link>
      </div>
      <user-evaluation :reply="reply"></user-evaluation>
    </div>
    <div class="superior" v-if="goodList.length > 0" id="title2">
      <div class="title acea-row row-center-wrapper">
        <img src="@assets/moblie/images/ling.png" />
        <div class="titleTxt">優品推薦</div>
        <img src="@assets/moblie/images/ling.png" />
      </div>
      <template>
        <div class="slider-banner banner">
          <swiper :options="swiperRecommend">
            <swiper-slide v-for="(item, index) in goodList" :key="index">
              <div class="list acea-row row-middle">
                <div
                  class="item"
                  v-for="val in item.list"
                  :key="val.image"
                  @click="goGoods(val)"
                >
                  <div class="pictrue">
                    <img :src="val.image" />
                    <span
                      class="pictrue_log pictrue_log_class"
                      v-if="val.activity && val.activity.type === '1'"
                      >秒杀</span
                    >
                    <span
                      class="pictrue_log pictrue_log_class"
                      v-if="val.activity && val.activity.type === '2'"
                      >砍价</span
                    >
                    <span
                      class="pictrue_log pictrue_log_class"
                      v-if="val.activity && val.activity.type === '3'"
                      >拼团</span
                    >
                  </div>
                  <div class="name line1">{{ val.store_name }}</div>
                  <div class="money font-color-red">val.price</div>
                </div>
              </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </template>
    </div>
    <div class="product-intro" id="title3">
      <div class="title">產品介紹</div>
      <div class="conter" v-html="storeInfo.description"></div>
    </div>
    <div style="height: 1.2rem"></div>
    <div class="footer acea-row row-between-wrapper">
      <div class="item" @click="toKefu">
        <div class="iconfont icon-kefu"></div>
        <div>客服</div>
      </div>
      <div class="item" v-if="id == '5241' || id == '5245'">
        <a target="_blank" @click="doDoctorAuth">
          <img class="doctor-image" src="@/assets/moblie/images/yisheng.png" />
          <div>问诊</div>
        </a>
      </div>
      <div class="item" @click="setCollect">
        <div
          class="iconfont"
          :class="storeInfo.userCollect ? 'icon-shoucang1' : 'icon-shoucang'"
        ></div>
        <div>收藏</div>
      </div>
      <router-link
        :to="'/cart'"
        class="item animated"
        :class="animated === true ? 'bounceIn' : ''"
      >
        <div class="iconfont icon-gouwuche1">
          <span class="num bg-color-red" v-if="CartCount > 0">{{
            CartCount
          }}</span>
        </div>
        <div>購物車</div>
      </router-link>
      <!-- <div
        class="btn-strict acea-row"
        v-if="(id == '5241' || id == '5245') && userInfo.is_buy == 1"
      >
        <a
          class="join-cart-strict"
          href="weixin://dl/business/?t=xVIqWR2lNAv"
          target="_blank"
          >加入購物車</a
        >
        <a
          class="buy-strict"
          href="weixin://dl/business/?t=xVIqWR2lNAv"
          target="_blank"
          >立即購買</a
        >
      </div> -->
      <div class="bnt acea-row">
        <div class="joinCart" @click="joinCart">加入購物車</div>
        <div class="buy" @click="tapBuy">立即購買</div>
      </div>
    </div>
    <!--
    <Share-red-packets
      :priceName="priceName"
      v-on:changeFun="changeFun"
      v-if="priceName !== 0"
    ></Share-red-packets>
  -->
    <CouponPop v-on:changeFun="changeFun" :coupon="coupon"></CouponPop>
    <Product-window
      v-on:changeFun="changeFun"
      :attr="attr"
      :storeInfo="storeInfo"
    ></Product-window>
    <StorePoster
      v-on:setPosterImageStatus="setPosterImageStatus"
      :posterImageStatus="posterImageStatus"
      :posterData="posterData"
    ></StorePoster>
    <ShareInfo
      v-on:setShareInfoStatus="setShareInfoStatus"
      :shareInfoStatus="shareInfoStatus"
    ></ShareInfo>
    <div
      class="generate-posters acea-row row-middle"
      :class="posters ? 'on' : ''"
    >
      <div
        class="item"
        v-if="weixinStatus === true"
        @click="setShareInfoStatus"
      >
        <div class="iconfont icon-weixin3"></div>
        <div class="">發送給朋友</div>
      </div>
      <div class="item" @click="setPosterImageStatus">
        <div class="iconfont icon-haibao"></div>
        <div class="">生成海報</div>
      </div>
    </div>
    <div
      class="mask"
      @touchmove.prevent
      @click="listenerActionClose"
      v-show="posters"
    ></div>
    <div class="geoPage" v-if="mapShow">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        :src="
          'https://apis.map.qq.com/uri/v1/geocoder?coord=' +
            system_store.latitude +
            ',' +
            system_store.longitude +
            '&referer=' +
            mapKey
        "
      >
      </iframe>
    </div>
    <!--
    <div class="form-content">
      <el-dialog
        title="资质认证"
        :visible.sync="centerDialogVisible"
        width="80%"
        top="30vh"
        center
        @close="$router.go(-1)"
      >
        <div class="del" @click="$router.go(-1)"></div>
        <span>需要您提供相关的资质认证</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="info" @click="changeUrl('company')">
            药企/研发认证
          </el-button>
          <el-button type="primary" @click="changeUrl('patient')"
            >病人资质认证</el-button
          >
        </span>
      </el-dialog>
    </div>-->
    <div class="form-content-1">
      <el-dialog
        title="溫馨提示"
        :visible="centerDialogVisiblej_statu"
        width="80%"
        top="30vh"
        center
      >
        <span>{{ judgeMsg }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="judgeStatu">確 定</el-button>
        </span>
      </el-dialog>
    </div>
    <el-dialog
      :visible.sync="TabooTips"
      width="70%"
      center
      top="30vh"
      :show-close="false"
    >
      <div class="dialog-tips">
        <img src="../../../assets/moblie/images/tipswithwords.png" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeTip">確 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="isShowNotice"
      width="70%"
      center
      top="30vh"
      :show-close="false"
    >
      <div class="dialog-tips" style="height: 0.5rem">
        为了更好的服务,我们联合全一,免费为您提供用药后医生随访服务
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeNotice">確 定</el-button>
      </span>
    </el-dialog>
    <!--
    <el-dialog
      :visible.sync="isShowHint"
      width="70%"
      center
      top="30vh"
      :show-close="false"
    >
      <div class="dialog-tips" style="text-align:center">
        受疫情影响清关时效将至少延迟7个工作日，因此整体物流时效将至少延迟15个工作日，下单默认知晓物流情况！
        <br />
        受当地防疫政策影响以下地区不接收国际件，因此暂停发货：全境（新疆、内蒙、河北、甘肃、黑龙江），河南（郑州、洛阳），湖北襄阳，广东（深圳、肇庆），安徽（黄山，宣城），福建宁德
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeHint">確 定</el-button>
      </span>
    </el-dialog>
  -->
    <el-dialog
      title="商品下单提示"
      :visible.sync="isShowAdvise"
      width="70%"
      center
      top="30vh"
      :show-close="false"
    >
      <div>
        建议您一次购买2支，2支均价更便宜！
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeSys">確 定</el-button>
      </span>
    </el-dialog>
    <!--
    <el-dialog
      title="商品下单提示"
      :visible.sync="isShowOrderHint1"
      width="70%"
      center
      top="30vh"
      :show-close="false"
    >
      <div>
        尊敬的用户您好，受疫情影响，物流时效将有所延迟，望知晓！再次为时效延迟深表歉意！
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeSys">確 定</el-button>
      </span>
    </el-dialog>-->
    <!--
    <el-dialog
      title="商品下单提示"
      :visible.sync="isShowOrderHint2"
      width="70%"
      center
      top="30vh"
      :show-close="false"
    >
      <div>
        尊敬的用户您好，受疫情影响，物流时效将有所延迟，望知晓！再次为时效延迟深表歉意！
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeSys">確 定</el-button>
      </span>
    </el-dialog>-->
    <!--
    <el-dialog
      title="商品下单提示"
      :visible.sync="isCanBuy"
      width="70%"
      center
      top="30vh"
      :show-close="false"
    >
      <div>
        由于台湾以及澳门疫情影响，货物无法发往香港仓，故暂时暂停下单，已下单的不受影响，对此我们深表歉意！
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeSys">確 定</el-button>
      </span>
    </el-dialog>-->
    <!-- <el-dialog
      title="温馨提示"
      :visible.sync="isSysWrong"
      width="70%"
      center
      top="30vh"
      :show-close="false"
    >
      <div>
        由于订单剧增产品已售罄，现在下单，预计于11月5号（周五）到货后按订单顺序陆续发出，介意勿拍
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeSys">確 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/moblie/css/swiper.min.css";
import ProductConSwiper from "@components/moblie/ProductConSwiper";
import UserEvaluation from "@components/moblie/UserEvaluation";
// import ShareRedPackets from "@components/moblie/ShareRedPackets";
import CouponPop from "@components/moblie/CouponPop";
import ProductWindow from "@components/moblie/ProductWindow";
import StorePoster from "@components/moblie/StorePoster";
import ShareInfo from "@components/moblie/ShareInfo";
import debounce from "lodash.debounce";
import {
  getProductDetail,
  postCartAdd,
  getCartCount,
  getProductCode,
  storeListApi,
  hospitalListApi
} from "@api/store";
import {
  getCoupon,
  getCollectAdd,
  getCollectDel,
  getUserInfo
} from "@api/user";
import { isWeixin } from "@utils/index";
import { wechatEvevt, oAuth } from "@libs/wechat";
import { imageBase64 } from "@api/public";
import { mapGetters } from "vuex";
import cookie from "@utils/store/cookie";
import { getWechatConfig } from "../../../api/public";
let NAME = "GoodsCon";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
export default {
  name: NAME,
  components: {
    swiper,
    swiperSlide,
    ProductConSwiper,
    UserEvaluation,
    // ShareRedPackets,
    CouponPop,
    ProductWindow,
    StorePoster,
    ShareInfo
  },
  data: function() {
    return {
      shareInfoStatus: false,
      weixinStatus: false,
      mapShow: false,
      mapKey: "",
      posterData: {
        image: "",
        title: "",
        price: "",
        code: ""
      },
      posterImageStatus: false,
      animated: false,
      coupon: {
        coupon: false,
        list: []
      },
      attr: {
        cartAttr: false,
        productAttr: [],
        productSelect: {}
      },
      isOpen: false, //是否打开属性组件
      productValue: [],
      id: 0,
      storeInfo: {},
      couponList: [],
      attrTxt: "請選擇",
      attrValue: "",
      cart_num: 1, //购买数量
      replyCount: "",
      replyChance: "",
      reply: [],
      priceName: 0,
      CartCount: 0,
      posters: false,
      banner: [{}, {}],
      swiperRecommend: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: false,
        loop: false,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      goodList: [],
      system_store: {},
      storeSelfMention: true,
      storeItems: {},
      activity: [],
      navList: [],
      lock: false,
      navActive: 0,
      opacity: 0,
      isSysced: false,
      isShowPrice: false, //不显示价格
      centerDialogVisiblej_statu: false, //判断审核的状态
      judgeMsg: "",
      is_certification: "",
      TabooTips: false,
      contraindications: "",
      chooseType: 1, // 1为立即购买，0为加入购物车
      hospitalItems: {}, // 门诊医院
      showAlert: false, // 加入购物车时，判定是否已经展示过
      userInfo: {},
      isSysWrong: false,
      isNoticed: false,
      isShowNotice: false,
      isShowHint: false,
      isHinted: false,
      isOrderHinted: false,
      isShowOrderHint1: false,
      isShowOrderHint2: false,
      isAdvised: false,
      isShowAdvise: false,
      isCanBuy: false
    };
  },
  computed: mapGetters(["isLogin"]),
  watch: {
    $route(n) {
      if (n.name === NAME) {
        this.id = n.params.id;
        this.storeInfo.slider_image = [];
        this.productCon();
        let { open } = this.$route.query;
        if (open) {
          this.goCat(0);
        }
      }
    }
  },
  updated() {
    // window.scroll(0, 0);
  },
  created: function() {
    let that = this;
    that.isSysWrong = false;
    getUserInfo()
      .then(res => {
        this.userInfo = res.data;
        if (res.status == 200) {
          let is_certification = res.data.is_certification;
          that.is_certification = is_certification;
          if (
            this.userInfo.certification_type == 1 &&
            !this.userInfo.spread_uid
          ) {
            this.$router.replace("/");
          }
        }
      })
      .catch(err => console.log(err));
  },
  mounted: function() {
    let url = window.location.href;
    console.log("token");
    console.log(this.$store.state.app.token);
    getWechatConfig(url).then(res => {
      console.log("wechat");
      console.log(res);
    });
    oAuth();
    let { open } = this.$route.query;
    if (open) {
      this.goCat(0);
    }
    document.addEventListener("scroll", this.onScroll, false);
    this.id = this.$route.params.id;
    this.storeInfo.slider_image = [];
    this.productCon();
    this.coupons();
    window.addEventListener("scroll", this.handleScroll);
    this.getList();
    this.getHospitalList();
  },
  methods: {
    // 商品详情跳转
    goDetail(item) {
      if (item.type === "1") {
        this.$router.push({
          path: "/activity/seckill_detail/" + item.id + "/" + item.time + "/1"
        });
      } else if (item.type === "2") {
        this.$router.push({
          path: "/activity/dargain_detail/" + item.id
        });
      } else {
        this.$router.push({
          path: "/activity/group_detail/" + item.id
        });
      }
    },
    // 获取门店列表数据
    getList() {
      let data = {
        latitude: cookie.get(LATITUDE) || "", //纬度
        longitude: cookie.get(LONGITUDE) || "", //经度
        page: 1,
        limit: 10
      };
      storeListApi(data)
        .then(res => {
          this.storeItems = res.data.list[0];
        })
        .catch(err => {
          console.log(err);
        });
    },
    doDoctorAuth() {
      let link = this.userInfo.doctor_link;
      let isAuth = localStorage.getItem("isAuth");
      if (isAuth) {
        return window.open(link);
      }
      let that = this;
      this.$dialog.confirm({
        mes: "是否授权全一e诊获取问诊信息？",
        opts: [
          {
            txt: "去授权",
            color: "red",
            callback: () => {
              localStorage.setItem("isAuth", true);
              window.open(link);
              console.log("授权");
            }
          },
          {
            txt: "取消",
            color: false,
            callback: () => {
              that.$dialog.toast({
                mes: "已取消"
              });
            }
          }
        ]
      });
    },
    // 获取已认证的医院
    getHospitalList() {
      let data = {
        latitude: cookie.get(LATITUDE) || "", //纬度
        longitude: cookie.get(LONGITUDE) || "", //经度
        page: 1,
        limit: 10,
        product_id: this.id
      };
      hospitalListApi(data).then(res => {
        if (res.data.list.length > 0) {
          this.hospitalItems = res.data.list[0];
        }
      });
    },
    handleScroll() {
      let top = document.body.scrollTop || document.documentElement.scrollTop;
      let opacity = top / 350;
      opacity = opacity > 1 ? 1 : opacity;
      this.opacity = opacity;
    },
    asideTap(a) {
      this.$nextTick(() => {
        let index = a;
        this.navActive = index;
        if (!this.goodList.length && index === 2) {
          index = 3;
        }
        let element = document.querySelector("#title" + index);
        const top =
          element.offsetTop - this.$refs.header.offsetHeight - window.scrollY;
        this.lock = true;
        window.scrollBy({ top, left: 0, behavior: "smooth" });
      });
    },
    onScroll: debounce(function() {
      // if (this.lock) {
      //   return;
      // }
      const headerHeight = this.$refs.header.offsetHeight,
        { scrollY } = window,
        titles = [];
      titles.push(document.querySelector("#title0"));
      titles.push(document.querySelector("#title1"));
      if (this.goodList.length) {
        titles.push(document.querySelector("#title2"));
      }
      titles.push(document.querySelector("#title3"));
      titles.reduce((initial, title, index) => {
        if (initial) return initial;
        if (scrollY + headerHeight < title.offsetTop + title.offsetHeight) {
          initial = true;
          this.navActive = index;
        }
        return initial;
      }, false);
      this.lock = true;
    }, 200),
    showChang: function() {
      if (isWeixin()) {
        let config = {
          latitude: parseFloat(this.storeItems.latitude),
          longitude: parseFloat(this.storeItems.longitude),
          name: this.storeItems.name,
          address: this.storeItems.address + this.system_store.detailed_address
        };
        wechatEvevt("openLocation", config)
          .then(res => {
            console.log(res);
          })
          .catch(res => {
            if (res.is_ready) {
              res.wx.openLocation(config);
            }
          });
      } else {
        if (!this.mapKey)
          return this.$dialog.error(
            "暫無法使用查看地圖，請配置您的騰訊地圖key"
          );
        this.mapShow = true;
      }
    },
    showHospital() {
      if (isWeixin()) {
        let config = {
          latitude: parseFloat(this.hospitalItems.latitude),
          longitude: parseFloat(this.hospitalItems.longitude),
          name: this.hospitalItems.name,
          address:
            this.hospitalItems.address + this.hospitalItems.detailed_address
        };
        wechatEvevt("openLocation", config)
          .then(res => {
            console.log(res);
          })
          .catch(res => {
            if (res.is_ready) {
              res.wx.openLocation(config);
            }
          });
      } else {
        if (!this.mapKey)
          return this.$dialog.error(
            "暫無法使用查看地圖，請配置您的騰訊地圖key"
          );
        this.mapShow = true;
      }
    },
    updateTitle() {
      document.title = this.storeInfo.store_name || this.$route.meta.title;
    },
    // 调转到门店列表
    showStoreList() {
      this.$store.commit("GET_TO", "details");
      this.$router.push("/shop/storeList/details");
    },
    // 跳转到医院列表
    showHospitalList() {
      this.$router.push("/shop/HospitalList/details?id=" + this.id);
    },
    setOpenShare: function() {
      var data = this.storeInfo;
      var href = location.href;
      if (isWeixin()) {
        if (this.isLogin) {
          getUserInfo().then(res => {
            if (
              res.data.certification_type === 1 &&
              res.data.spread_uid !== 0
            ) {
              href =
                href.indexOf("?") === -1
                  ? href + "?spread=" + res.data.spread_uid
                  : href + "&spread=" + res.data.spread_uid;
            } else {
              href =
                href.indexOf("?") === -1
                  ? href + "?spread=" + res.data.uid
                  : href + "&spread=" + res.data.uid;
            }

            var configAppMessage = {
              desc: data.store_info,
              title: data.store_name,
              link: href,
              imgUrl: data.image
            };
            wechatEvevt(
              ["updateAppMessageShareData", "updateTimelineShareData"],
              configAppMessage
            )
              .then(res => {
                console.log(res);
              })
              .catch(res => {
                if (res.is_ready) {
                  res.wx.updateAppMessageShareData(configAppMessage);
                  res.wx.updateTimelineShareData(configAppMessage);
                }
              });
          });
        } else {
          var configAppMessage = {
            desc: data.store_info,
            title: data.store_name,
            link: href,
            imgUrl: data.image
          };
          wechatEvevt(
            ["updateAppMessageShareData", "updateTimelineShareData"],
            configAppMessage
          )
            .then(res => {
              console.log(res);
            })
            .catch(res => {
              if (res.is_ready) {
                res.wx.updateAppMessageShareData(configAppMessage);
                res.wx.updateTimelineShareData(configAppMessage);
              }
            });
        }
      }
    },
    setShareInfoStatus: function() {
      this.shareInfoStatus = !this.shareInfoStatus;
      this.posters = false;
    },
    shareCode: function(value) {
      var that = this;
      getProductCode(that.id).then(res => {
        if (res.data.code) that.posterData.code = res.data.code;
        value === false && that.listenerActionSheet();
      });
    },
    setPosterImageStatus: function() {
      var sTop = document.body || document.documentElement;
      sTop.scrollTop = 0;
      this.posterImageStatus = !this.posterImageStatus;
      this.posters = false;
    },
    //产品详情接口；
    productCon: function() {
      let that = this;
      let spread = this.$route.query.spread;
      getProductDetail(spread, that.id)
        .then(res => {
          that.$set(that, "storeInfo", res.data.storeInfo);
          that.$set(that.attr, "productAttr", res.data.productAttr);
          that.$set(that, "productValue", res.data.productValue);
          that.$set(that, "replyCount", res.data.replyCount);
          that.$set(that, "replyChance", res.data.replyChance);
          that.reply = res.data.reply ? [res.data.reply] : [];
          that.$set(that, "reply", that.reply);
          that.$set(that, "priceName", res.data.priceName);
          that.posterData.image = that.storeInfo.image_base;
          that.activity = res.data.activity ? res.data.activity : [];
          if (that.storeInfo.store_name.length > 30) {
            that.posterData.title =
              that.storeInfo.store_name.substring(0, 30) + "...";
          } else {
            that.posterData.title = that.storeInfo.store_name;
          }
          that.storeSelfMention = res.data.store_self_mention ? true : false;
          that.posterData.price = that.storeInfo.price;
          that.posterData.code = that.storeInfo.code_base;
          that.system_store = res.data.system_store;
          let good_list = res.data.good_list || [];
          let goodArray = [];
          let count = Math.ceil(good_list.length / 6);
          for (let i = 0; i < count; i++) {
            var list = good_list.slice(i * 6, i * 6 + 6);
            if (list.length) goodArray.push({ list: list });
          }
          that.mapKey = res.data.mapKey;
          that.$set(that, "goodList", goodArray);
          let navList = ["商品", "評價", "詳情"];
          if (goodArray.length) {
            navList.splice(2, 0, "推薦");
          }
          that.navList = navList;
          that.updateTitle();
          that.DefaultSelect();
          that.getCartCount();
          that.getImageBase64();
          that.setOpenShare();
          getUserInfo()
            .then(res => {
              this.userInfo = res.data;
            })
            .catch(err => console.log(err));
        })
        .catch(res => {
          that.$dialog.error(res.msg);
          that.$router.go(-1);
        });
    },
    getImageBase64: function() {
      let that = this;
      imageBase64(this.posterData.image, that.posterData.code)
        .then(res => {
          that.posterData.image = res.data.image;
          that.posterData.code = res.data.code;
          that.isLogin && that.shareCode();
        })
        .catch(() => {
          that.isLogin && that.shareCode();
        });
    },
    //默认选中属性；
    DefaultSelect: function() {
      let productAttr = this.attr.productAttr,
        value = [];
      for (var key in this.productValue) {
        if (this.productValue[key].stock > 0) {
          value = this.attr.productAttr.length ? key.split(",") : [];
          break;
        }
      }
      for (let i = 0; i < productAttr.length; i++) {
        this.$set(productAttr[i], "index", value[i]);
      }
      //sort();排序函数:数字-英文-汉字；
      let productSelect = this.productValue[value.sort().join(",")];
      if (productSelect && productAttr.length) {
        this.$set(
          this.attr.productSelect,
          "store_name",
          this.storeInfo.store_name
        );
        this.$set(this.attr.productSelect, "image", productSelect.image);
        this.$set(this.attr.productSelect, "price", productSelect.price);
        this.$set(this.attr.productSelect, "stock", productSelect.stock);
        this.$set(this.attr.productSelect, "unique", productSelect.unique);
        this.$set(this.attr.productSelect, "cart_num", 1);
        if (this.id == 5245 || this.id == 5259)
          this.$set(this.attr.productSelect, "cart_num", 2);
        this.$set(this, "attrValue", value.sort().join(","));
        this.$set(this, "attrTxt", "已選擇");
      } else if (!productSelect && productAttr.length) {
        this.$set(
          this.attr.productSelect,
          "store_name",
          this.storeInfo.store_name
        );
        this.$set(this.attr.productSelect, "image", this.storeInfo.image);
        this.$set(this.attr.productSelect, "price", this.storeInfo.price);
        this.$set(this.attr.productSelect, "stock", 0);
        this.$set(this.attr.productSelect, "unique", "");
        this.$set(this.attr.productSelect, "cart_num", 0);
        this.$set(this, "attrValue", "");
        this.$set(this, "attrTxt", "請選擇");
      } else if (!productSelect && !productAttr.length) {
        this.$set(
          this.attr.productSelect,
          "store_name",
          this.storeInfo.store_name
        );
        this.$set(this.attr.productSelect, "image", this.storeInfo.image);
        this.$set(this.attr.productSelect, "price", this.storeInfo.price);
        this.$set(this.attr.productSelect, "stock", this.storeInfo.stock);
        this.$set(
          this.attr.productSelect,
          "unique",
          this.storeInfo.unique || ""
        );
        this.$set(this.attr.productSelect, "cart_num", 1);
        this.$set(this, "attrValue", "");
        this.$set(this, "attrTxt", "請選擇");
      }
    },
    //购物车；
    ChangeCartNum: function(changeValue) {
      console.log(changeValue);
      //changeValue:是否 加|减
      //获取当前变动属性
      let productSelect = this.productValue[this.attrValue];
      //如果没有属性,赋值给商品默认库存
      if (productSelect === undefined && !this.attr.productAttr.length)
        productSelect = this.attr.productSelect;
      //无属性值即库存为0；不存在加减；
      if (productSelect === undefined) return;
      let stock = productSelect.stock || 0;
      let num = this.attr.productSelect;
      if (changeValue) {
        num.cart_num++;
        if (num.cart_num > stock) {
          this.$set(this.attr.productSelect, "cart_num", stock);
          this.$set(this, "cart_num", stock);
        }
      } else {
        console.log("-");
        num.cart_num--;
        if (this.id == 5259) {
          num.cart_num = 2;
          this.$set(this.attr.productSelect, "cart_num", 2);
          this.$set(this, "cart_num", 2);
        }
        if (num.cart_num < 1) {
          this.$set(this.attr.productSelect, "cart_num", 1);
          this.$set(this, "cart_num", 1);
        }
      }
    },
    //将父级向子集多次传送的函数合二为一；
    changeFun: function(opt) {
      if (typeof opt !== "object") opt = {};
      let action = opt.action || "";
      let value = opt.value === undefined ? "" : opt.value;
      this[action] && this[action](value);
    },
    //打开优惠券插件；
    couponTap: function() {
      let that = this;
      that.coupons();
      that.coupon.coupon = true;
    },
    changecoupon: function(msg) {
      this.coupon.coupon = msg;
      this.coupons();
    },
    currentcoupon: function(res) {
      let that = this;
      that.coupon.coupon = false;
      that.$set(that.coupon.list[res], "is_use", true);
    },
    //可领取优惠券接口；
    coupons: function() {
      let that = this,
        q = { page: 1, limit: 20, type: 1, product_id: that.id };
      getCoupon(q).then(res => {
        that.$set(that, "couponList", res.data || []);
        that.$set(that.coupon, "list", res.data);
      });
    },
    //打开属性插件；
    selecAttrTap: function() {
      this.attr.cartAttr = true;
      this.isOpen = true;
    },
    changeattr: function(msg) {
      this.attr.cartAttr = msg;
      this.isOpen = false;
    },
    //选择属性；
    ChangeAttr: function(res) {
      let productSelect = this.productValue[res];
      if (productSelect) {
        this.$set(this.attr.productSelect, "image", productSelect.image);
        this.$set(this.attr.productSelect, "price", productSelect.price);
        this.$set(this.attr.productSelect, "stock", productSelect.stock);
        this.$set(this.attr.productSelect, "unique", productSelect.unique);
        if(productSelect.product_id==5259){
        this.$set(this.attr.productSelect, "cart_num", 2);
        }else{
        this.$set(this.attr.productSelect, "cart_num", 1);
        }
        this.$set(this, "attrValue", res);
        this.$set(this, "attrTxt", "已選擇");
      } else {
        this.$set(this.attr.productSelect, "image", this.storeInfo.image);
        this.$set(this.attr.productSelect, "price", this.storeInfo.price);
        this.$set(this.attr.productSelect, "stock", 0);
        this.$set(this.attr.productSelect, "unique", "");
        this.$set(this.attr.productSelect, "cart_num", 0);
        this.$set(this, "attrValue", "");
        this.$set(this, "attrTxt", "請選擇");
      }
    },
    //收藏商品
    setCollect: function() {
      let that = this,
        id = that.storeInfo.id,
        category = "product";
      if (that.storeInfo.userCollect) {
        getCollectDel(id, category).then(function() {
          that.storeInfo.userCollect = !that.storeInfo.userCollect;
        });
      } else {
        getCollectAdd(id, category).then(function() {
          that.storeInfo.userCollect = !that.storeInfo.userCollect;
        });
      }
    },
    goGoods(item) {
      if (item.activity && item.activity.type === "1") {
        this.$router.push({
          path:
            "/activity/seckill_detail/" +
            item.activity.id +
            "/" +
            item.activity.time +
            "/1"
        });
      } else if (item.activity && item.activity.type === "2") {
        this.$router.push({
          path: "/activity/dargain_detail/" + item.activity.id
        });
      } else if (item.activity && item.activity.type === "3") {
        this.$router.push({
          path: "/activity/group_detail/" + item.activity.id
        });
      } else {
        this.$router.push({ path: "/detail/" + item.id });
      }
    },
    //  点击加入购物车按钮
    joinCart: function() {
      console.log("enter joincart");
      // if (!this.isHinted) {
      //   this.isHinted = true;
      //   return (this.isShowHint = true);
      // }
      let { id, isAdvised } = this;
      let a = true;
      /*
      if (a) {
        console.log(a)
        return (this.isCanBuy = true);
      }*/
      if (!isAdvised && (id == 5254 ||id == 5255)) {
        this.isAdvised = true;
        return (this.isShowAdvise = true);
      }
      if ((this.id == "5245" || this.id == "5241") && !this.isNoticed) {
        this.isNoticed = true;
        return (this.isShowNotice = true);
      }
      console.log("over isnoticed");
      // if (
      //   (this.id == "4985" || this.id == "5241" || this.id == "5244") &&
      //   !this.isSysced
      // ) {
      //   this.isSysced = true;
      //   return (this.isSysWrong = true);
      // }
      // console.log("over isSys");
      if (
        this.userInfo.spread_uid == 0 &&
        this.userInfo.certification_type == 1
      ) {
        return this.$dialog.toast({
          mes: "請聯繫醫院購買"
        });
      }
      if (this.userInfo.isAgree == 2) {
        return this.$dialog.toast({
          mes: "暂无购买权限，请联系客服"
        });
      }
      // 当禁忌症展示过一次，第二次就不用再次展示
      if (this.showAlert) {
        this.goCat(0);
        return;
      }
      if (!this.storeInfo.contraindications) {
        this.goCat(0);
      } else {
        this.TabooTips = true;
        this.chooseType = 0;
        this.showAlert = true;
      }
    },
    // 加入购物车；
    goCat: function(news) {
      let that = this,
        productSelect = that.productValue[this.attrValue];
      //打开属性
      if (that.attrValue) {
        //默认选中了属性，但是没有打开过属性弹窗还是自动打开让用户查看默认选中的属性
        that.attr.cartAttr = !that.isOpen ? true : false;
      } else {
        if (that.isOpen) that.attr.cartAttr = true;
        else that.attr.cartAttr = !that.attr.cartAttr;
      }
      //只有关闭属性弹窗时进行加入购物车
      if (that.attr.cartAttr === true && that.isOpen === false)
        return (that.isOpen = true);
      if (
        !this.attr.productSelect.cart_num ||
        parseInt(this.attr.productSelect.cart_num) <= 0
      )
        return that.$dialog.toast({ mes: "請輸入購買數量" });
      // if (
      //   (this.id == "4985" || this.id == "5241" || this.id == "5244") &&
      //   !this.isSysced
      // ) {
      //   this.isSysced = true;
      //   return (this.isSysWrong = true);
      // }
      //如果有属性,没有选择,提示用户选择
      if (
        that.attr.productAttr.length &&
        productSelect === undefined &&
        that.isOpen === true
      )
        return that.$dialog.toast({ mes: "產品庫存不足，請選擇其它" });
      let q = {
        productId: that.id,
        cartNum: that.attr.productSelect.cart_num,
        new: news,
        uniqueId:
          that.attr.productSelect !== undefined
            ? that.attr.productSelect.unique
            : ""
      };
      postCartAdd(q)
        .then(function(res) {
          that.isOpen = false;
          that.attr.cartAttr = false;
          if (news) {
            if (that.userInfo.pay_count == 0) {
              console.log("gogog");
              that.$router.push({ path: `/order/follow/${res.data.cartId}` });
            } else {
              that.$router.push({ path: "/order/submit/" + res.data.cartId });
            }
          } else {
            that.$dialog.toast({
              mes: "添加購物車成功",
              callback: () => {
                that.getCartCount(true);
              }
            });
          }
        })
        .catch(res => {
          console.log(res);
          that.isOpen = false;
          return that.$dialog.toast({ mes: res.msg });
        });
    },
    //获取购物车数量
    getCartCount: function(isAnima) {
      let that = this;
      const isLogin = that.isLogin;
      if (isLogin) {
        getCartCount({ numType: 0 }).then(res => {
          that.CartCount = res.data.count;
          //加入购物车后重置属性
          if (isAnima) {
            that.animated = true;
            setTimeout(function() {
              that.animated = false;
            }, 500);
          }
        });
      }
    },
    orderHint1() {
      this.isShowOrderHint1 = false;
    },
    orderHint2() {
      this.isShowOrderHint2 = false;
    },
    //立即购买；
    tapBuy: function() {
      console.log("enter tapbuy");
      // if (!this.isHinted) {
      //   this.isHinted = true;
      //   return (this.isShowHint = true);
      // }
      let { id, isOrderHinted, isAdvised } = this;
      let a = true;
      /*
      if (a) {
        return (this.isCanBuy = true);
      }*/
      if (!isAdvised && (id == 5254 ||id==5255) ) {
        this.isAdvised = true;
        return (this.isShowAdvise = true);
      }
      if (
        (id == "4984" ||
          id == "25" ||
          id == "5257" ||
          id == "5255" ||
          id == "5254" ||
          id == "5253" ||
          id == "5252" ||
          id == "5250" ||
          id == "5249" ||
          id == "5246" ||
          id == "5245" ||
          id == "5243" ||
          id == "5242") &&
        !isOrderHinted
      ) {
        this.isOrderHinted = true;
        this.orderHint1();
      }
      if (
        (id == "5247" ||
          id == "5256" ||
          id == "5244" ||
          id == "5241" ||
          id == "4985") &&
        !isOrderHinted
      ) {
        this.isOrderHinted = true;
        this.orderHint2();
      }
      if ((this.id == "5245" || this.id == "5241") && !this.isNoticed) {
        this.isNoticed = true;
        return (this.isShowNotice = true);
      }
      console.log("over isNoticed");
      // 当禁忌症展示过一次，第二次就不用再次展示
      if (
        this.userInfo.spread_uid == 0 &&
        this.userInfo.certification_type == 1
      ) {
        return this.$dialog.toast({
          mes: "請聯繫醫院購買"
        });
      }
      if (this.userInfo.isAgree == 2) {
        return this.$dialog.toast({
          mes: "暂无购买权限，请联系客服"
        });
      }
      if (this.showAlert) {
        this.goCat(1);
        return;
      }
      if (!this.storeInfo.contraindications) {
        this.goCat(1);
      } else {
        this.TabooTips = true;
        this.chooseType = 1;
        this.showAlert = true;
      }
    },
    //回到首頁
    backHome() {
      // 当禁忌症展示过一次，第二次就不用再次展示
      if (
        this.userInfo.spread_uid == 0 &&
        this.userInfo.certification_type == 1
      ) {
        this.$dialog.toast({
          mes: "請聯繫醫院購買"
        });
        let that = this;
        setTimeout(() => {
          that.$router.push("/");
        }, 1000);
      }
      // if (this.showAlert) {
      //   this.goCat(1);
      //   return;
      // }
      // if (!this.storeInfo.contraindications) {
      //   this.goCat(1);
      // } else {
      //   this.TabooTips = true;
      //   this.chooseType = 1;
      //   this.showAlert = true;
      // }
    },
    closeTip() {
      this.TabooTips = false;
      //chooseType  1=直接购买, 0=加入购物车
      this.goCat(this.chooseType);
    },
    closeNotice() {
      this.isShowNotice = false;
      this.isNoticed = true;
    },
    closeHint() {
      this.isShowHint = false;
      this.isHinted = true;
    },
    closeSys() {
      // this.isSysWrong = false;
      // this.isSysced = true;
      //this.goCat(this.chooseType);
      //this.backHome();
      this.isOrderHinted = true;
      this.isShowOrderHint1 = false;
      this.isShowOrderHint2 = false;
      this.isShowAdvise = false;
      this.isCanBuy = false;
    },
    listenerActionSheet: function() {
      if (isWeixin() === true) {
        this.weixinStatus = true;
      }
      this.posters = true;
    },
    listenerActionClose: function() {
      this.posters = false;
    },
    changeUrl: function(type) {
      if (type == "company") {
        this.$router.push("/shop/authenticate/company");
      } else {
        this.$router.push("/shop/authenticate/patient");
      }
    },
    toKefu() {
      window.location.href =
         "https://work.weixin.qq.com/kfid/kfc17fdc05b8b6141ec";
      //this.$router.push("/customer/list");
    },
    // 第二个弹窗，判断是否审核状态
    judgeStatu: function() {
      if (this.is_certification == 2) {
        this.$router.go(-1);
      } else {
        this.centerDialogVisiblej_statu = false;
        this.centerDialogVisible = true;
      }
    }
  },
  beforeDestroy: function() {
    document.removeEventListener("scroll", this.onScroll, false);
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style scoped>
.mask {
  z-index: 888 !important;
}
.activity_pin {
  width: auto;
  height: 0.44rem;
  background: linear-gradient(
    90deg,
    rgba(233, 51, 35, 1) 0%,
    rgba(250, 101, 20, 1) 100%
  );
  opacity: 1;
  border-radius: 0.22rem;
  padding: 0 0.2rem;
  margin-left: 0.19rem;
}
.activity_miao {
  width: auto;
  height: 0.44rem;
  padding: 0 0.2rem;
  background: linear-gradient(
    90deg,
    rgba(250, 102, 24, 1) 0%,
    rgba(254, 161, 15, 1) 100%
  );
  opacity: 1;
  border-radius: 0.22rem;
  margin-left: 0.19rem;
}
.iconfonts {
  color: #fff !important;
  font-size: 0.28rem;
  display: block;
}
.activity_title {
  font-size: 0.24rem;
  color: #fff;
}
.activity_kan {
  width: auto;
  height: 0.44rem;
  padding: 0 0.2rem;
  background: linear-gradient(
    90deg,
    rgba(254, 159, 15, 1) 0%,
    rgba(254, 178, 15, 1) 100%
  );
  opacity: 1;
  border-radius: 0.22rem;
  margin-left: 0.19rem;
}
.addressBox .phone {
  margin-left: 1.1rem;
}
.corlor-red {
  color: #fc4141;
}
.store-box {
  padding: 0 0.3rem;
  border-bottom: 1px solid #f5f5f5;
}
.geoPage {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 10000;
}
.product-con .header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 0.96rem;
  font-size: 0.3rem;
  color: #050505;
  background-color: #fff;
  z-index: 11;
  border-bottom: 0.01rem solid #eee;
}
.product-con .header .item {
  position: relative;
  margin: 0 0.35rem;
}
.product-con .header .item.on:before {
  position: absolute;
  width: 0.6rem;
  height: 0.05rem;
  background-repeat: no-repeat;
  content: "";
  background: linear-gradient(to left, #ff3366 0%, #ff6533 100%);
  background: -webkit-linear-gradient(to left, #ff3366 0%, #ff6533 100%);
  background: -moz-linear-gradient(to left, #ff3366 0%, #ff6533 100%);
  bottom: -0.1rem;
}
.product-con .store-info {
  margin-top: 0.2rem;
  background-color: #fff;
}
.product-con .store-info .title {
  font-size: 0.28rem;
  color: #282828;
  height: 0.8rem;
  line-height: 0.8rem;
  border-bottom: 0.01rem solid #f5f5f5;
}
.product-con .store-info .info {
  padding: 0 0.3rem;
  height: 1.26rem;
}
.store-info .icon-jiantou {
  color: #7a7a7a;
  font-size: 0.28rem;
}
.product-con .store-info .info .pictrue {
  width: 0.76rem;
  height: 0.76rem;
}
.product-con .store-info .info .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 0.06rem;
}
.product-con .store-info .info .text {
  width: 56%;
}
.product-con .store-info .info .text .name {
  font-size: 0.3rem;
  color: #282828;
}
.product-con .store-info .info .text .address {
  font-size: 0.24rem;
  color: #666;
  margin-top: 0.03rem;
}
.product-con .store-info .info .text .address .iconfont {
  color: #707070;
  font-size: 0.18rem;
  margin-left: 0.1rem;
}
.address_tit {
  max-width: 88% !important;
}
.addressTxt {
  width: auto;
  font-size: 0.24rem;
}
.product-con .store-info .info .iconfont {
  font-size: 0.4rem;
}
.product-con .superior {
  background-color: #fff;
  margin-top: 0.2rem;
}
.product-con .superior .title {
  height: 0.98rem;
}
.product-con .superior .title img {
  width: 0.3rem;
  height: 0.3rem;
}
.product-con .superior .title .titleTxt {
  margin: 0 0.2rem;
  font-size: 0.3rem;
  background-image: linear-gradient(to right, #f57a37 0%, #f21b07 100%);
  background-image: -webkit-linear-gradient(to right, #f57a37 0%, #f21b07 100%);
  background-image: -moz-linear-gradient(to right, #f57a37 0%, #f21b07 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.product-con .superior .slider-banner {
  width: 6.9rem;
  margin: 0 auto;
  padding-bottom: 0.2rem;
}
.store-name {
  width: 4.3rem;
}
.product-con .superior .slider-banner .list {
  width: 100%;
  padding-bottom: 0.2rem;
}
.product-con .superior .slider-banner .list .item {
  width: 2.15rem;
  margin: 0 0.21rem 0.2rem 0;
  font-size: 0.26rem;
}
.product-con .superior .slider-banner .list .item:nth-of-type(3n) {
  margin-right: 0;
}
.product-con .superior .slider-banner .list .item .pictrue {
  width: 100%;
  height: 2.15rem;
  position: relative;
}
.product-con .superior .slider-banner .list .item .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 0.06rem;
}
.product-con .superior .slider-banner .list .item .name {
  color: #282828;
  margin-top: 0.12rem;
}
.product-con .superior .slider-banner .swiper-pagination-bullet {
  background-color: #999;
}
.product-con .superior .slider-banner .swiper-pagination-bullet-active {
  background-color: #e93323;
}

.mask {
  -webkit-filter: blur(2px);
  -moz-filter: blur(2px);
  -ms-filter: blur(2px);
  filter: blur(2px);
  z-index: 888 !important;
}
.footer .icon-shoucang1 {
  color: #e93323;
}
.product-con .product-intro .conter div {
  width: 100% !important;
}
.generate-posters {
  width: 100%;
  height: 1.7rem;
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 999;
  transform: translate3d(0, 100%, 0);
  -webkit-transform: translate3d(0, 100%, 0);
  -ms-transform: translate3d(0, 100%, 0);
  -moz-transform: translate3d(0, 100%, 0);
  -o-transform: translate3d(0, 100%, 0);
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -o-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  opacity: 0;
}
.generate-posters.on {
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
  opacity: 1;
}
.generate-posters .item {
  flex: 50%;
  -webkit-flex: 50%;
  -ms-flex: 50%;
  text-align: center;
}
.generate-posters .item .iconfont {
  font-size: 0.8rem;
  color: #5eae72;
}
.generate-posters .item .iconfont.icon-haibao {
  color: #5391f1;
}
.noscroll {
  height: 100%;
  overflow: hidden;
}
.form-content /deep/ .el-dialog__body,
.form-content-1 /deep/ .el-dialog__body {
  text-align: center;
  font-size: 16px;
}
.form-content /deep/ .el-dialog__footer {
  padding: 10px 0 20px;
}
.form-content /deep/ .el-button {
  padding: 12px 5px;
  font-size: 16px;
  font-weight: 700;
}
.form-content-1 /deep/ .el-dialog__headerbtn {
  display: none;
}
.del {
  position: absolute;
  width: 0.4rem;
  height: 0.4rem;
  right: 5%;
  top: 3vh;
}
.z-index /deep/ .el-dialog__wrapper {
  z-index: 3000 !important;
}
.detail-content {
  margin-top: -5px;
  padding: 0 15px 5px;
}
.detail-content > p {
  font-size: 0.26rem;
  color: #82848f;
  line-height: 24px;
}
.tax-content {
  border-top: 0.2rem solid rgb(245, 245, 245);
  padding: 0.1rem 0.3rem;
  color: #82848f;
}
.tax-item {
  padding: 0.2rem 0;
}
.tax-item:not(:last-child) {
  border-bottom: 0.01rem solid lightgray;
}
.assurance {
  display: flex;
  align-items: center;
}
.assure {
  color: #fff;
  padding: 0.02rem 0.1rem;
  margin-right: 0.1rem;
  border-radius: 0.1rem;
}
</style>
<style>
.el-loading-mask {
  opacity: 0.75;
}
.el-dialog__wrapper {
  overflow: hidden;
}
.dialog-tips {
  width: 100%;
  height: 3.5rem;
  /* background-image: url("../../../assets/moblie/images/tipswithwords.png");
  background-repeat: no-repeat;
  background-size: 100% 100%; */
}
.dialog-tips img {
  width: 100%;
  height: 100%;
}
.doctor-image {
  width: 20px;
  height: 20px;
}
.product-con .btn-strict {
  color: #ffffff;
  width: 50%;
  height: 0.7rem;
  text-align: center;
}
.product-con .btn-strict a {
  width: 50%;
  line-height: 0.7rem;
}
.product-con .join-cart-strict {
  border-radius: 0.5rem 0 0 0.5rem;
  background-image: linear-gradient(to right, #fea10f 0%, #fa8013 100%);
  background-image: -webkit-linear-gradient(to right, #fea10f 0%, #fa8013 100%);
  background-image: -moz-linear-gradient(to right, #fea10f 0%, #fa8013 100%);
}
.product-con .buy-strict {
  border-radius: 0 0.5rem 0.5rem 0;
  background-image: linear-gradient(to right, #fa6514 0%, #e93323 100%);
  background-image: -webkit-linear-gradient(to right, #fa6514 0%, #e93323 100%);
  background-image: -moz-linear-gradient(to right, #fa6514 0%, #e93323 100%);
}
</style>
